// extracted by mini-css-extract-plugin
module.exports = {"btn":"DisableDevice_btn__2Ra5L"};